import { Theme } from "@mui/material/styles";
import pxToRem from "assets/theme/functions/pxToRem";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    alignItems: "flex-start",
  },
  bodyContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: 1,
    minHeight: 0,
  },
  // Single card wraps trigger + text so one continuous shadow covers both when expanded.
  itemCard: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: 0,
    background: theme.palette.white.main,
    borderRadius: pxToRem(24),
    boxShadow: theme.boxShadows.soft,
    overflow: "hidden",
  },
  itemCardExpanded: {
    flex: 1,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: pxToRem(14),
    margin: 0,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    textAlign: "inherit",
    fontFamily: "inherit",
    color: "inherit",
    minHeight: pxToRem(106),
    flexShrink: 0,
  },
  fileRow: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  detailsContainerLTR: {
    marginLeft: theme.spacing.spacing12_5,
  },
  detailsContainerRTL: {
    marginRight: theme.spacing.spacing12_5,
  },
  detailsTitle: {
    display: "flex",
    flexDirection: "column",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.sm,
    lineHeight: "20px",
  },
  date: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
  },
  toggleIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginLeft: theme.spacing.spacing4,
    marginRight: theme.spacing.spacing4,
    transition: "transform 200ms ease",
    color: theme.palette.primary.main,
  },
  toggleIconLTR: {
    transform: "rotate(180deg)",
  },
  toggleIconRTL: {
    transform: "rotate(0deg)",
  },
  toggleIconExpanded: {
    transform: "rotate(90deg)",
  },
  content: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    whiteSpace: "pre-line",
    paddingLeft: pxToRem(14),
    paddingRight: pxToRem(14),
    transition: "max-height 250ms ease, opacity 200ms ease, padding 200ms ease",
  },
  contentCollapsed: {
    maxHeight: 0,
    paddingBottom: 0,
    overflow: "hidden",
    opacity: 0,
  },
  contentExpanded: {
    flex: 1,
    minHeight: 0,
    maxHeight: "100%",
    paddingBottom: pxToRem(14),
    overflowY: "auto",
    opacity: 1,
  },
  approveCheckBoxContainer: {
    margin: `${theme.spacing.spacing7} 0 ${theme.spacing.spacing7}`,
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
  },
  checkBoxLTR: {
    padding: `${theme.spacing.spacing4} ${theme.spacing.spacing4} ${theme.spacing.spacing4} 0px!important`,
  },
  checkBoxRTL: {
    padding: `${theme.spacing.spacing4} 0px ${theme.spacing.spacing4} ${theme.spacing.spacing4}!important`,
  },
});
